<app-breadcrumb [master]="'Sprzedaż'" [parentName]="'Lista importów'" [name]="'Lista importów'"></app-breadcrumb>
<div class="sold-policy-import-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="sold-policy-import-list-filters">
    <mat-form-field class="sold-policy-import-list-filter">
      <mat-label>Nazwa</mat-label>
      <input matInput placeholder="Nazwa.csv" name="contains$name" ngModel>
    </mat-form-field>

    <app-dict [multiple]="false" label="Firma" class="sold-policy-import-list-filter" ngModel name="company" dictType="company"></app-dict>

    <app-dict-insurance-companies [multiple]="true" label="TU" class="sold-policy-import-list-filter" ngModel name="insuranceCompany"></app-dict-insurance-companies>

    <app-datepicker
      class="sold-policy-import-list-filter"
      label="Data utworzenia od"
      placeholder="2000-01-01"
      [required]="false"
      ngModel name="gte$createdAt"
    ></app-datepicker>

    <app-datepicker
      class="sold-policy-import-list-filter"
      label="Data utworzenia do"
      placeholder="2000-01-01"
      [required]="false"
      ngModel name="lte$createdAt"
    ></app-datepicker>

    <app-dict-users label="Użytkownik" class="sold-policy-import-list-filter" ngModel name="createdBy"></app-dict-users>

    <app-dict [multiple]="false" label="Status" class="sold-policy-import-list-filter" ngModel name="status" dictType="import_status"></app-dict>

  </form>

  <div class="sold-policy-import-list-buttons">
    <button  *ngIf="(userPermissions | async).registration.read_report"  (click)="downloadReport()" [disabled]="!(userPermissions | async).registration.read_report"
            mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>

  <table mat-table [dataSource]="imports">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> Nazwa </th>
      <td mat-cell *matCellDef="let element">
        {{element.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="company">
      <th mat-header-cell *matHeaderCellDef> Firma </th>
      <td mat-cell *matCellDef="let element">
        {{element.company?.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="insuranceCompany">
      <th mat-header-cell *matHeaderCellDef> TU </th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="element.insuranceCompany" class="default-link" [routerLink]="['/tu/szczegoly', element.insuranceCompany.id]">
          {{element.insuranceCompany.name}}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef> Data utworzenia </th>
      <td mat-cell *matCellDef="let element">
        {{element.createdAt | date:'y-MM-dd HH:mm'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="createdBy">
      <th mat-header-cell *matHeaderCellDef> Użytkownik </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.createdBy">
          <div class="circular-image">
            <img class="circular-image small-avatar import-list-avatar"
                 [src]="'/rest/sso/api/user/' + element.createdBy.uuid + '/avatar'" (error)="onImgError($event)"
                 alt="Zdjęcie"/>
          </div>
          <a class="default-link" [routerLink]="['/uzytkownicy/szczegoly', element.createdBy.uuid]">{{element.createdBy.firstName}} {{element.createdBy.lastName}}</a>
        </ng-container>
        <ng-container *ngIf="!element.createdBy">
          System
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="totalRows">
      <th mat-header-cell *matHeaderCellDef> Liczba wierszy </th>
      <td mat-cell *matCellDef="let element">
        {{element.importedRows}}/{{element.totalRows}}
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status </th>
      <td mat-cell *matCellDef="let element">
        <button *ngIf="element.status" mat-raised-button [ngClass]="element.status.color + '-button'">
          {{element.status.name}}
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button [matMenuTriggerFor]="menu"><mat-icon>expand_more</mat-icon></button>
        <mat-menu #menu="matMenu" xPosition="before">
          <button mat-menu-item (click)="downloadImportFile(element)">Pobierz plik importu</button>
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
